import { render, staticRenderFns } from "./BlockZero.vue?vue&type=template&id=48b81431&scoped=true&"
import script from "./BlockZero.vue?vue&type=script&lang=js&"
export * from "./BlockZero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b81431",
  null
  
)

export default component.exports